import { Product } from '../../types';

export const series0187Products: Product[] = [
  {
    id: "bt-0187-swt011011",
    name: "0110/0187 Series Terminal - 2.8 Male CDI Patti (SWT011011)",
    slug: "0110-0187-series-terminal-2-8-male-cdi-patti-swt011011",
    category: "Brass Terminal",
    subcategory: "0187 Series",
    description: "2.8mm male CDI Patti terminal. Elongated male terminal for CDI applications.",
    partNumber: "SWT011011",
    specifications: {
      "Tab Size Ø": "2.8 mm",
      "Cable Size SQ. MM": "N/A",
      "Description": "2.8 Male CDI Patti",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-N/A Cut-1000",
    },
    images: ["/products/brass-terminals/0187-series/SWT011011.jpg"],
    tags: ["terminal", "0187", "0110", "brass", "male", "cdi", "patti", "2.8mm"],
    applications: ["Automotive", "CDI Applications"],
  },
  {
    id: "bt-0187-swt018700s",
    name: "0187 Series Terminal - 4.8 Female Slot (SWT018700S)",
    slug: "0187-series-terminal-4-8-female-slot-swt018700s",
    category: "Brass Terminal",
    subcategory: "0187 Series",
    description: "4.8mm female slot terminal. Blade terminal for medium duty applications.",
    partNumber: "SWT018700S",
    specifications: {
      "Tab Size Ø": "4.80 mm",
      "Cable Size SQ. MM": "1.30-2.30",
      "Description": "4.8 Female Slot",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-8000 Cut-1000",
    },
    images: ["/products/brass-terminals/0187-series/SWT018700S.jpg"],
    tags: ["terminal", "0187", "brass", "female", "slot", "4.8mm"],
    applications: ["Automotive", "Medium Duty"],
  },
  {
    id: "bt-0187-swt018700l",
    name: "0187 Series Terminal - 4.8 Female Lock (SWT018700L)",
    slug: "0187-series-terminal-4-8-female-lock-swt018700l",
    category: "Brass Terminal",
    subcategory: "0187 Series",
    description: "4.8mm female lock terminal with locking feature. Blade terminal for medium duty applications.",
    partNumber: "SWT018700L",
    featured: true,
    specifications: {
      "Tab Size Ø": "4.80 mm",
      "Cable Size SQ. MM": "1.30-2.30",
      "Description": "4.8 Female Lock",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-8000 Cut-1000",
    },
    images: ["/products/brass-terminals/0187-series/SWT018700L.jpg"],
    tags: ["terminal", "0187", "brass", "female", "lock", "4.8mm"],
    applications: ["Automotive", "Medium Duty"],
  },
  {
    id: "bt-0187-swt018711",
    name: "0187 Series Terminal - 4.8 Positive Lock (SWT018711)",
    slug: "0187-series-terminal-4-8-positive-lock-swt018711",
    category: "Brass Terminal",
    subcategory: "0187 Series",
    description: "4.8mm positive lock terminal with prominent positive locking tab. Enhanced retention mechanism.",
    partNumber: "SWT018711",
    specifications: {
      "Tab Size Ø": "4.80 mm",
      "Cable Size SQ. MM": "1.20-2.00",
      "Description": "4.8 Positive Lock",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-8000",
    },
    images: ["/products/brass-terminals/0187-series/SWT018711.jpg"],
    tags: ["terminal", "0187", "brass", "female", "positive-lock", "4.8mm"],
    applications: ["Automotive", "Medium Duty"],
  },
  {
    id: "bt-0187-swt018712",
    name: "0187 Series Terminal - 4.8 Female In Lock (SWT018712)",
    slug: "0187-series-terminal-4-8-female-in-lock-swt018712",
    category: "Brass Terminal",
    subcategory: "0187 Series",
    description: "4.8mm female in lock terminal with internal locking feature. Enhanced retention mechanism.",
    partNumber: "SWT018712",
    specifications: {
      "Tab Size Ø": "4.80 mm",
      "Cable Size SQ. MM": "1.20-2.00",
      "Description": "4.8 Female In Lock",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-8000",
    },
    images: ["/products/brass-terminals/0187-series/SWT018712.jpg"],
    tags: ["terminal", "0187", "brass", "female", "in-lock", "4.8mm"],
    applications: ["Automotive", "Medium Duty"],
  },
  {
    id: "bt-0187-swt018715",
    name: "0187 Series Terminal - 4.8 Male (SWT018715)",
    slug: "0187-series-terminal-4-8-male-swt018715",
    category: "Brass Terminal",
    subcategory: "0187 Series",
    description: "4.8mm male terminal with flat rectangular tab. Blade terminal for medium duty applications.",
    partNumber: "SWT018715",
    specifications: {
      "Tab Size Ø": "0.50 mm",
      "Cable Size SQ. MM": "1.50-2.30",
      "Description": "4.8 Male",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-7000 Cut-1000",
    },
    images: ["/products/brass-terminals/0187-series/SWT018715.jpg"],
    tags: ["terminal", "0187", "brass", "male", "4.8mm"],
    applications: ["Automotive", "Medium Duty"],
  },
  {
    id: "bt-0187-swt018716",
    name: "0187 Series Terminal - 5.1 Male Patti (SWT018716)",
    slug: "0187-series-terminal-5-1-male-patti-swt018716",
    category: "Brass Terminal",
    subcategory: "0187 Series",
    description: "5.1mm male Patti terminal with very thin elongated tab. For specialized applications.",
    partNumber: "SWT018716",
    specifications: {
      "Tab Size Ø": "0.30 mm",
      "Cable Size SQ. MM": "0.90-1.50",
      "Description": "5.1 Male Patti",
      "Material": "CuZn-63/37",
      "Standard Packing": "Spool-10000 Cut-1000",
    },
    images: ["/products/brass-terminals/0187-series/SWT018716.jpg"],
    tags: ["terminal", "0187", "brass", "male", "patti", "5.1mm"],
    applications: ["Automotive", "Specialized Applications"],
  },
];
